import { render, staticRenderFns } from "./VozGuidelineStrikingSection.vue?vue&type=template&id=344b8b5e"
import script from "./VozGuidelineStrikingSection.vue?vue&type=script&lang=ts"
export * from "./VozGuidelineStrikingSection.vue?vue&type=script&lang=ts"
import style0 from "./VozGuidelineStrikingSection.vue?vue&type=style&index=0&id=344b8b5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports